export const sectionTitle = 'Sessions';

export const rowsLimit = 10;
export const defaultRowsLimit = 5;
